export default __webpack_public_path__ + "static/media/fridge1-before2-1440w.330b76dd.avif";